var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 252 252",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.6,74.6l-83.8,83.8l-25.5-25.5c-3.5-3.5-9.2-3.5-12.7,0s-3.5,9.2,0,12.7l31.9,31.9c1.8,1.8,4.1,2.6,6.4,2.6 c2.3,0,4.6-0.9,6.4-2.6l90.1-90.1c3.5-3.5,3.5-9.2,0-12.7C189.9,71.1,184.1,71.1,180.6,74.6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,0C56.5,0,0,56.5,0,126s56.5,126,126,126s126-56.5,126-126S195.5,0,126,0z M126,234c-59.6,0-108-48.4-108-108 S66.4,18,126,18s108,48.4,108,108S185.6,234,126,234z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.521d1654.svg";
export { ForwardRef as ReactComponent };